export default {
    GET_USERNAME: "passwordRecovery/GET_USERNAME",
    GET_USERNAME_SUCCESS: "passwordRecovery/GET_USERNAME_SUCCESS",
    GET_USERNAME_FAILED: "passwordRecovery/GET_USERNAME_FAILED",

    CHANGE_PASSWORD: "passwordRecovery/CHANGE_PASSWORD",
    CHANGE_PASSWORD_SUCCESS: "passwordRecovery/ CHANGE_PASSWORD_SUCCESS",
    CHANGE_PASSWORD_FAILED: "passwordRecovery/ CHANGE_PASSWORD_FAILED"
}
